<template>
  <div class="bg-gray-200 md:border-l border-gray-400" v-if="initialCheck">
    <button v-if="!isLive" class="btn-xs btn-blue" @click="makeLive">Make Live</button>
    <div v-else>
      <div class="bg-gray-300 py-2 mb-2">
        <p class="text-center font-medium mb-1">Live Event Controller</p>
        <div class="flex justify-center space-x-3  border-b ">
          <button class="btn-sm btn-green text-sm" @click="addAnnouncement=true">New Announcement</button>
          <button class="btn-sm btn-blue text-sm" @click="addRing=true">New Ring</button>
        </div>
        <div class="flex justify-center">
          <button v-if="!editAnnouncements" class="btn-link" @click="editAnnouncements=true">Edit Announcements</button>
          <button v-else class="btn-link" @click="editAnnouncements=false">Done Editing</button>
        </div>
      </div>
      <div v-if="editAnnouncements" class="px-3">
        <div v-for="a in eventAnnouncments" :key="a.id" class="flex items-center justify-between">
          <input v-model="a.message" class="new-form-input w-full">
          <button class="btn-link" @click="updateAnnounecment(a)">Edit</button>
          <!--<button class="btn-link" @click="deleteAnnoucement(a)">X</button>-->
        </div>
      </div>
      <div v-else class="px-3">
        <div v-if="addAnnouncement" id="announcement" class="mx-auto w-full py-4 border-b">
          <textarea v-model="announcement" type="text" rows="4" class="new-form-input w-full mx-auto"></textarea>
          <div class="mt-2 flex justify-center space-x-2">
            <button class="btn-sm btn-blue" @click="postAnnouncement">Post announcement</button>
            <button class="btn-link" @click="addAnnouncement=false">Cancel</button>
          </div>
        </div>
        <div v-if="addRing" class="mx-auto w-full py-4 border-b">
          <label>Ring Name</label>
          <input v-model="newRing" type="text" class="mt-2 new-form-input w-full">
          <div class="mt-2 flex justify-center space-x-2">
            <button class="btn-sm btn-blue" @click="createRing">Create Ring</button>
            <button class="btn-link" @click="addRing=false">Cancel</button>
          </div>
        </div>
        <div class="flex flex-col space-y-4">
          <div v-for="(r, i) in eventRings" :key="i" class="">
            <p class="text-xl text-center">{{r.name}}</p>
            <div class="">
              <label class="text-sm mb-1 font-medium">Show In Ring</label>
              <multiselect ref="show_dropdown" @input="updateCurrentShow(r)" v-model="r.current_show" :options="adminData.show_books" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" placeholder="Select a show" label="name" :preselect-first="false" :custom-label="(option) => {return option.name}" :hideSelected="true"></multiselect>
            </div>
            <div class="">
              <label class="text-sm mb-1 font-medium">Class In Ring</label>
              <multiselect ref="clas_dropdown" @input="updateRing(r)" v-model="r.in_ring" :options="currentClasses" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" placeholder="Select a show" label="name" :preselect-first="false" :custom-label="(option) => {return option.full_class_name}" :hideSelected="true"></multiselect>
            </div>
            <div class="flex justify-center mt-2">
              <button class="btn-xs btn-red" @click="removeRing(r.id)">Remove Ring</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      eventAnnouncments: [],
      initialCheck: false,
      eventRings: [],
      addRing: false,
      newRing: null,
      editAnnouncements: false,
      isLive: false,
      addAnnouncement: false,
      announcement: null,
      currentClasses: []
    }
  },
  computed: {
    adminData () {
      return this.$store.state.admin.adminData
    },
    event () {
      return this.adminData.event
    }
  },
  methods: {
    checkIfLive () {
      this.$store.state.apiInstance.get(`/live/check-live?event_id=${this.event.event_id}`)
        .then(response => {
          this.initialCheck = true
          this.isLive = response.data.length
          if (this.isLive) {
            this.eventRings = response.data[0].rings
            this.eventAnnouncments = response.data[0].announcements
          }
        })
    },
    makeLive () {
      this.$store.state.apiInstance.post('/live/create-live', this.event)
        .then(response => {
          this.isLive = true
        })
        .catch(() => {
        })
    },
    postAnnouncement () {
      this.$store.state.apiInstance.post('/live/postAnnouncement', {event_id: this.event.event_id, announcement: this.announcement})
        .then(response => {
          this.announcement = null
          this.addAnnouncement = false
        })
        .catch(() => {
        })
    },
    createRing () {
      this.$store.state.apiInstance.post('/live/createRing', {event_id: this.event.event_id, ring: this.newRing})
        .then(response => {
          this.eventRings.push(response.data.data[0])
          this.newRing = null
          this.addRing = false
        })
        .catch(() => {
        })
    },
    removeRing (ringID) {
      this.$store.state.apiInstance.post('/live/removeRing', {id: ringID})
        .then(response => {
          this.eventRings = this.eventRings.filter(obj => obj.id !== ringID)
        })
        .catch(() => {
        })
    },
    setClasses (classes) {
      this.currentClasses = classes.filter(c => c.entryType === 'standard' && c.full_class_name)
    },
    updateRing (r) {
      let currentClassIndex = this.currentClasses.findIndex(obj => {
        if (obj.class_number === r.in_ring.class_number) {
          return true
        }
      })
      r.last_class = this.currentClasses[currentClassIndex - 1]
      r.on_deck = this.currentClasses[currentClassIndex + 1]
      this.$store.state.apiInstance.post('/live/updateClassInRing', r)
        .then(() => {
        })
        .catch(() => {
        })
    },
    updateCurrentShow (r) {
      this.$store.state.apiInstance.post('/live/updateCurrentShow', r)
        .then(() => {
        })
        .catch(() => {
        })
    },
    updateAnnounecment (a) {
      this.$store.state.apiInstance.post('/live/updateAnnounecment', a)
        .then(response => {
        })
        .catch(() => {
        })
    },
    deleteAnnoucement (a) {
      this.$store.state.apiInstance.delete('/live/deleteAnnouncement', {id: a.id})
        .then(response => {
          this.announcements = this.announcements.filter(obj => obj.id !== a.id)
        })
        .catch(() => {
        })
    }
  },
  mounted () {
    this.checkIfLive()
  }
}
</script>

<style>

</style>
